document.addEventListener("DOMContentLoaded", function () {
  const root = document.getElementById("byb-live-leaderboard");
  if (!root) return;

  const CSV = root.dataset.csv;
  const REFRESH = parseInt(root.dataset.refresh || "5000", 10);
  const TOTAL_ROUNDS = parseInt(root.dataset.totalRounds || "9", 10);

  const body = document.getElementById("byb-body");
  const status = document.getElementById("byb-status");
  const roundEl = document.getElementById("byb-round");

  let lastRenderedSignature = "";
  let highestRoundSeen = 0;
  let timer = null;
  let isLoading = false;

  function parseCSVLine(line) {
    const result = [];
    let current = "";
    let inQuotes = false;

    for (let i = 0; i < line.length; i++) {
      const char = line[i];
      const next = line[i + 1];

      if (char === '"') {
        if (inQuotes && next === '"') {
          current += '"';
          i++;
        } else {
          inQuotes = !inQuotes;
        }
      } else if (char === "," && !inQuotes) {
        result.push(current);
        current = "";
      } else {
        current += char;
      }
    }

    result.push(current);
    return result;
  }

  function parseCSV(text) {
    const lines = text
      .replace(/\r/g, "")
      .split("\n")
      .filter(line => line.trim() !== "");

    let round = null;
    let headerIndex = -1;

    for (let i = 0; i < lines.length; i++) {
      const cols = parseCSVLine(lines[i]).map(v => v.trim());

      if (cols[0] === "Runde" && cols[1]) {
        round = cols[1];
      }

      if (cols[0] === "Rank") {
        headerIndex = i;
        break;
      }
    }

    if (headerIndex === -1) {
      return { round: round, rows: [] };
    }

    const headers = parseCSVLine(lines[headerIndex]).map(h => h.trim());

    const rows = lines.slice(headerIndex + 1).map(line => {
      const cols = parseCSVLine(line);
      const obj = {};

      headers.forEach((h, i) => {
        obj[h] = (cols[i] || "").trim();
      });

      return obj;
    });

    return { round: round, rows: rows };
  }

  function trendClass(symbol) {
    if (symbol === "▲") return "trend-up";
    if (symbol === "▼") return "trend-down";
    return "trend-same";
  }

  function scheduleNext() {
    clearTimeout(timer);
    timer = setTimeout(load, REFRESH);
  }

  async function load() {
    if (isLoading) return;
    isLoading = true;

    try {
      status.textContent = "Aktualisiere…";

      const fetchUrl =
        CSV +
        (CSV.includes("?") ? "&" : "?") +
        "_ts=" +
        Date.now() +
        "_" +
        Math.random().toString(36).slice(2);

      const res = await fetch(fetchUrl, {
        cache: "no-store"
      });

      if (!res.ok) throw new Error("HTTP " + res.status);

      const text = await res.text();
      const parsed = parseCSV(text);
      const roundNum = parseInt(parsed.round, 10);

      const rows = parsed.rows
        .map(r => ({
          rank: parseInt(r.Rank, 10),
          team: (r.Team || "").trim(),
          table: (r.Tisch || "").trim(),
          points: parseInt(r.Punkte, 10),
          trend: (r.Trend || "–").trim()
        }))
        .filter(r => r.team && !Number.isNaN(r.rank))
        .sort((a, b) => {
          if (a.rank !== b.rank) return a.rank - b.rank;
          return a.team.localeCompare(b.team, "de");
        });

      if (!Number.isNaN(roundNum) && highestRoundSeen > 0 && roundNum < highestRoundSeen) {
        status.textContent = "Live";
        scheduleNext();
        return;
      }

      if (!Number.isNaN(roundNum) && roundNum > highestRoundSeen) {
        highestRoundSeen = roundNum;
      }

      const signature = JSON.stringify({
        round: parsed.round || "",
        rows: rows
      });

      if (signature === lastRenderedSignature) {
        status.textContent = "Live";

        if (roundEl) {
          roundEl.textContent =
            !Number.isNaN(roundNum) && roundNum > 0
              ? "Runde " + roundNum + " / " + TOTAL_ROUNDS
              : "Runde – / " + TOTAL_ROUNDS;
        }

        scheduleNext();
        return;
      }

      lastRenderedSignature = signature;
      body.innerHTML = "";

      rows.forEach(r => {
        const tr = document.createElement("tr");

        if (r.rank === 1) tr.classList.add("top1");
        if (r.rank === 2) tr.classList.add("top2");
        if (r.rank === 3) tr.classList.add("top3");

        if (r.trend === "▲") tr.classList.add("row-up");
        if (r.trend === "▼") tr.classList.add("row-down");

        tr.innerHTML = `
          <td class="rank-col"><span class="rank-badge">${r.rank}</span></td>
          <td class="team-col"><span class="team-name">${r.team}</span></td>
          <td class="points-col">${Number.isNaN(r.points) ? "" : r.points}</td>
          <td class="trend-col ${trendClass(r.trend)}">${r.trend}</td>
          <td class="table-col">${r.table}</td>
        `;

        body.appendChild(tr);
      });

      status.textContent = "Live";

      if (roundEl) {
        roundEl.textContent =
          !Number.isNaN(roundNum) && roundNum > 0
            ? "Runde " + roundNum + " / " + TOTAL_ROUNDS
            : "Runde – / " + TOTAL_ROUNDS;
      }
    } catch (e) {
      status.textContent = "Fehler";
      console.error(e);
    } finally {
      isLoading = false;
      scheduleNext();
    }
  }

  load();
});